import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import type { BundledExperienceRowView } from '../../tabs/bundledExperiences/types';
import type { WithChecklistItemMetadata } from '../../types';
import { presentRowBase } from '../rowBase';

export function presentBundledExperienceRows(
  rows: Array<CmChecklist.BundledExperienceRow>,
): Array<WithChecklistItemMetadata<BundledExperienceRowView>> {
  return rows.map((row) => ({
    ...presentRowBase(row),
    blackoutsOk: row.evidence.blackouts_ok,
    bookBy: row.evidence.book_by ?? undefined,
    bookByComparison: { ok: row.evidence.book_by_ok },
    bundledExperience: row.subject.name ?? row.subject.ancillary_deal_option_id ?? row.subject.bundled_experience_id,
    childAge: row.evidence.child_age ?? undefined,
    childAgeOk: row.evidence.child_age_ok,
    currency: row.evidence.currency ?? undefined,
    currencyOk: row.evidence.currency_ok,
    field: 'Bundled Experiences',
    hotelBookBy: row.evidence.hotel_book_by ?? undefined,
    hotelTravelTo: row.evidence.hotel_travel_to ?? undefined,
    linkedDealOptions: row.subject.linked_deal_option_names,
    travelTo: row.evidence.travel_to ?? undefined,
    travelToComparison: { ok: row.evidence.travel_to_ok },
    validityOk: row.evidence.validity_ok,
  }));
}
